import { useState, useEffect, useCallback } from "react";
import { api } from "../lib/api";
import { FilterBar } from "../components/FilterBar";
import { OpportunityCard } from "../components/OpportunityCard";
import { AccessGate } from "../components/AccessGate";

export default function Embed() {
  const [opps, setOpps] = useState([]);
  const [loading, setLoading] = useState(true);
  const [category, setDiscipline] = useState("All");
  const [focus, setFocus] = useState("All");
  const [search, setSearch] = useState("");
  const [sort, setSort] = useState("deadline");
  const [settings, setSettings] = useState(null);

  useEffect(() => {
    api.get("/settings").then(({ data }) => setSettings(data)).catch(() => {});
  }, []);

  const load = useCallback(async () => {
    setLoading(true);
    const params = { sort };
    if (category !== "All") params.discipline = category;
    if (focus !== "All") params.focus = focus;
    if (search) params.search = search;
    const { data } = await api.get("/opportunities", { params });
    setOpps(data);
    setLoading(false);
  }, [category, focus, search, sort]);

  useEffect(() => {
    const t = setTimeout(load, 250);
    return () => clearTimeout(t);
  }, [load]);

  // Auto-resize: tell the parent WordPress page our real height so the iframe fits.
  useEffect(() => {
    const postHeight = () => {
      const h = document.body.scrollHeight;
      window.parent?.postMessage({ type: "rawfemme-embed-height", height: h }, "*");
    };
    postHeight();
    const ro = new ResizeObserver(postHeight);
    ro.observe(document.body);
    window.addEventListener("load", postHeight);
    return () => { ro.disconnect(); window.removeEventListener("load", postHeight); };
  }, [opps, loading]);

  const s = settings || {};

  return (
    <AccessGate>
    <div data-testid="embed-view" className="bg-white p-4 sm:p-6">
      <div className="sticky top-0 z-10 bg-white pb-4 border-b-2 border-black mb-6">
        <FilterBar {...{ discipline: category, setDiscipline, focus, setFocus, search, setSearch, sort, setSort }} />
      </div>
      {loading ? (
        <p data-testid="loading-state" className="label-caps text-black/50 py-16 text-center">Loading…</p>
      ) : opps.length === 0 ? (
        <p data-testid="empty-state" className="label-caps text-black/50 py-16 text-center">No matches found.</p>
      ) : (
        <>
          <p data-testid="results-count" className="label-caps text-black/50 mb-6">{opps.length} Opportunities</p>
          <div className="grid gap-5 sm:grid-cols-2 lg:grid-cols-3">
            {opps.map((o) => <OpportunityCard key={o.id} opp={o} />)}
          </div>
        </>
      )}

      {/* Submit CTA — under the listings */}
      <div className="mt-12 border-t-2 border-black pt-8 text-center">
        <h3 className="font-display font-black uppercase tracking-tighter text-xl sm:text-2xl mb-3">{s.submit_heading || "Know of a Grant, Residency, Job or Open Call?"}</h3>
        <a href={`${window.location.origin}/submit`} target="_blank" rel="noopener noreferrer" data-testid="submit-cta-btn"
          className="inline-flex items-center gap-2 label-caps bg-pink text-black px-8 py-3 border-2 border-black brutal-shadow-sm hover:-translate-y-0.5 transition-transform">
          {s.submit_button || "Submit an Opportunity"}
        </a>
      </div>
    </div>
    </AccessGate>
  );
}
